import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ENDPOINTS from '../../utils/api';

// Async Thunk to fetch waste types
export const fetchWasteTypes = createAsyncThunk(
  'wasteTypes/fetchWasteTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.WASTE_TYPES());
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch waste types'
      );
    }
  }
);

// Initial state
const initialState = {
  wasteTypes: [],
  loading: false,
  error: null,
};

// Create slice
const wasteTypeSlice = createSlice({
  name: 'wasteTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWasteTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWasteTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.wasteTypes = action.payload?.data || [];
      })
      .addCase(fetchWasteTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default wasteTypeSlice.reducer;
